import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { Button } from 'primereact/button';

import FormInputText from '../../components/form/FormInputText';
import { IntegrationSettings } from '../../models/integrationSettings';
import { IntegrationStatus, IntegrationVendor } from '../../models/enums/integrationEnums';
import { parseIntegrationData } from '../../utils/misc-utils';

type EmpowerLosFormValues = {
  realECLenderPartyId: string;
};

interface EditEmpowerLosIntegrationSettingsProps {
  onCancel: () => void;
  onSave?: (_settings: IntegrationSettings) => void;
  integrationSettings?: IntegrationSettings;
  environment: string;
}

export const EditEmpowerLosIntegrationSettings = ({
  onCancel,
  onSave,
  integrationSettings,
  environment,
}: EditEmpowerLosIntegrationSettingsProps): JSX.Element => {
  const isEditMode = !!integrationSettings;

  let realECLenderPartyId = '';
  if (isEditMode && integrationSettings?.integrationData) {
    const data = parseIntegrationData(integrationSettings.integrationData);
    realECLenderPartyId = data.realECLenderPartyId || '';
  }

  const validationSchema = yup.object().shape({
    realECLenderPartyId: yup.string().required('RealEC Lender Party ID is required'),
  });

  const { control, handleSubmit, formState } = useForm<EmpowerLosFormValues>({
    defaultValues: {
      realECLenderPartyId: realECLenderPartyId,
    },
    resolver: yupResolver(validationSchema),
    mode: 'onSubmit',
  });

  const { errors } = formState;

  return (
    <div className="surface-section p-4 border-1 surface-border border-round mb-3">
      <h3 className="mt-0 mb-3">{isEditMode ? 'Edit Empower LOS Settings' : 'Empower LOS Settings'}</h3>
      <form
        autoComplete="off"
        onSubmit={handleSubmit((data) => {
          if (onSave) {
            let settings: IntegrationSettings;

            if (isEditMode && integrationSettings) {
              settings = {
                ...integrationSettings,
                vendor: IntegrationVendor.Empower,
                environment: environment,
                integrationData: JSON.stringify({
                  realECLenderPartyId: data.realECLenderPartyId,
                }),
              };
            } else {
              settings = {
                name: 'Empower LOS Integration',
                vendor: IntegrationVendor.Empower,
                status: IntegrationStatus.Active,
                environment: environment,
                integrationData: JSON.stringify({
                  realECLenderPartyId: data.realECLenderPartyId,
                }),
              };
            }

            onSave(settings);
          }
        })}
        noValidate
        className="pb-3 p-fluid p-input-filled"
      >
        <h4 className="mt-0 mb-3">RealEC Exchange Connection</h4>

        <div className="field mb-4">
          <FormInputText
            control={control}
            errors={errors}
            field="realECLenderPartyId"
            label="RealEC Lender Party ID *"
            placeholder="Enter RealEC Lender Party ID"
          />
        </div>

        <div className="flex justify-content-end gap-2 mt-4" style={{ zIndex: 1000 }}>
          <Button
            type="button"
            label="Cancel"
            className="p-button p-button-outlined"
            style={{ width: 'auto', minWidth: 'auto' }}
            onClick={onCancel}
          />
          <Button
            type="submit"
            label={isEditMode ? 'Update' : 'Save'}
            className="p-button"
            style={{ width: 'auto', minWidth: 'auto' }}
          />
        </div>
      </form>
    </div>
  );
};
